<template>
  <div class="userInformation boxCore" id="tradingFeeSetting">
    <div class="content_TradingFeeSetting clearfix">
      <div class="filter_container clearfix">
        <span>
          <span class="title_item">{{
            $t("trading_fee_setting.trading_selectMarket")
          }}</span>
          <select-box v-model="currency" :options="markets" />
        </span>
        <span>
          <span style="margin-inline-start: 32px" class="title_item"
            >Select Membership</span
          >
          <select-box v-model="membership" :options="memberships" />
        </span>
      </div>
      <div class="clearfix"></div>

      <div class="datatable">
        <data-table
          :getData="getData"
          ref="tradeFeeDatatable"
          :limit="10"
          :column="6"
          class="scroll"
          @DataTable:finish="onDatatableFinish"
        >
          <th class="text-left col-coin">
            {{ $t("trading_fee_setting.coin") }}
          </th>
          <th class="text-left col-fee-taker">
            {{ $t("trading_fee_setting.fee_taker") }} (%)
          </th>
          <th class="text-left col-fee-maker">
            {{ $t("trading_fee_setting.fee_maker") }} (%)
          </th>
          <th class="last-table text-right"></th>
          <template slot="body" slot-scope="props">
            <tr>
              <td class="text-left trading-coin">
                {{ props.item.coin }}
              </td>
              <td class="text-left">
                <input-only-number
                  v-if="props.item.editable"
                  name="fee_taker"
                  class="form-control fl-left"
                  v-model="props.item.feeTaker"
                  @dirty="onHandleDirtyData($event, props.item)"
                  maxlength="7"
                  precision="4"
                />
                <span v-else
                  >{{
                    !props.item.feeTaker
                      ? ""
                      : Number(props.item.feeTaker) | toNumber
                  }}
                  {{ !props.item.feeTaker ? "" : "%" }}</span
                >
              </td>
              <td class="text-left">
                <input-only-number
                  v-if="props.item.editable"
                  class="form-control fl-left"
                  name="fee_maker"
                  precision="4"
                  v-model="props.item.feeMaker"
                  @dirty="onHandleDirtyData($event, props.item)"
                  maxlength="7"
                />
                <span v-else
                  >{{
                    !props.item.feeMaker
                      ? ""
                      : Number(props.item.feeMaker) | toNumber
                  }}
                  {{ !props.item.feeMaker ? "" : "%" }}</span
                >
              </td>
              <td class="text-right">
                <button
                  v-if="props.item.editable"
                  class="btn btn_save_network"
                  :disabled="isRevertDisabled(props.item)"
                  @click="revert(props.item)"
                >
                  <i class="icon-reload3"></i>
                </button>
                <button
                  v-if="props.item.editable"
                  class="btn btn_save_network"
                  @click="change(props.item)"
                >
                  <i class="icon-save"></i>
                </button>
                <button
                  v-else
                  class="btn btn_edit_network"
                  @click="edit(props.item)"
                >
                  <i class="icon-edit"></i>
                </button>
              </td>
            </tr>
          </template>
        </data-table>
      </div>
    </div>

    <div class="clearfix clearfix-40"></div>
    <div class="line_page"></div>

    <div class="content_WithdrawFeeSetting clearfix">
      <withdraw-fee-setting />
    </div>

    <loading-modal />
  </div>
</template>
<script>
import rf from "../../lib/RequestFactory";
import InputOnlyNumber from "../circuit_breaker/InputOnlyNumberCircuitBreaker";
import WithdrawFeeSetting from "./WithdrawFeeSetting";
import SelectBox from "../../components/SelectBox";
import BigNumber from "bignumber.js";
import LoadingModal from "@/modals/common/LoadingModal.vue";

export default {
  components: {
    WithdrawFeeSetting,
    InputOnlyNumber,
    SelectBox,
    LoadingModal,
  },
  data() {
    return {
      titlePage: this.$t("trading_fee_setting.trading_fee_setting"),
      showInputFee: false,
      currency: { id: "usdt", name: "USDT" },
      markets: [],
      membership: { id: "gold", name: "Gold" },
      memberships: [
        { id: "gold", name: "Gold" },
        { id: "platinum", name: "Platinum" },
      ],
      firstDataLoadDone: false,
    };
  },

  watch: {
    currency(newValue) {
      this.$refs.tradeFeeDatatable.refresh();
    },
    membership(newValue) {
      this.$refs.tradeFeeDatatable.refresh();
    },
  },
  computed: {
    trimZeroNumber: function (item) {
      return item.fixed(2);
    },
  },

  methods: {
    getData(params) {
      const defaultParams = {
        currency: this.currency.id,
        membership_level: this.membership.id,
      };
      const shouldShowLoading = !this.firstDataLoadDone;

      if (shouldShowLoading) this.$modal.show("modal-loading");

      return rf
        .getRequest("AdminRequest")
        .getMarketFeeSetting(Object.assign(defaultParams, params))
        .then((res) => {
          const payload = res && res.data ? res.data : {};
          const {
            items = [],
            limit = 10,
            page = 1,
            total = 0,
            totalPages = 1,
          } = payload;

          const mappedItems = items.map((el) => {
            return {
              ...el,
              feeTaker: el.feeTaker
                ? new BigNumber(el.feeTaker)
                    .toFixed(4)
                    .replace(/(?:(\.\d*?[1-2]+)|\.)0*$/gm, "$1")
                : 0,
              feeMaker: el.feeMaker
                ? new BigNumber(el.feeMaker)
                    .toFixed(4)
                    .replace(/(?:(\.\d*?[1-2]+)|\.)0*$/gm, "$1")
                : 0,
            };
          });

          return {
            data: {
              data: mappedItems,
              current_page: page,
              total: total,
              last_page: totalPages,
              per_page: limit,
            },
          };
        })
        .finally(() => {
          if (shouldShowLoading) {
            this.firstDataLoadDone = true;
            this.$modal.hide("modal-loading");
          }
        });
    },

    onDatatableFinish() {
      window._.each(this.$refs.tradeFeeDatatable.rows, (item) => {
        this.$set(item, "editable", false);
        this.$set(item, "isDirty", false);
      });
    },

    onHandleDirtyData($event, item) {
      item.isDirty = $event;
    },

    isRevertDisabled(item) {
      if (!item.isDirty) return true;
      if (!item.revert) return true;

      const currentTaker = String(item.feeTaker || 0);
      const currentMaker = String(item.feeMaker || 0);
      const originalTaker = String(item.revert.fee_taker || 0);
      const originalMaker = String(item.revert.fee_maker || 0);

      return currentTaker === originalTaker && currentMaker === originalMaker;
    },

    edit(item) {
      item.revert = {
        fee_taker: item.feeTaker,
        fee_maker: item.feeMaker,
      };
      item.editable = !item.editable;
    },
    resetErrors() {
      this.error_validate.fee_taker = false;
      this.error_validate.free_maker = false;
    },
    checkValidatePercent(item) {
      if (!item.feeTaker && item.feeTaker !== 0 && item.feeTaker !== "0") {
        this.$toastr(
          "error",
          this.$t("trading_fee_setting.validate.required", {
            0: this.$t("tradding_fee_setting.fee_taker"),
          })
        );
        return false;
      }
      if (typeof item.feeTaker === "string" && !item.feeTaker.trim()) {
        this.$toastr(
          "error",
          this.$t("trading_fee_setting.validate.required", {
            0: this.$t("tradding_fee_setting.fee_taker"),
          })
        );
        return false;
      }
      if (!item.feeMaker && item.feeMaker !== 0 && item.feeMaker !== "0") {
        this.$toastr(
          "error",
          this.$t("trading_fee_setting.validate.required", {
            0: this.$t("tradding_fee_setting.fee_maker"),
          })
        );
        return false;
      }
      if (typeof item.feeMaker === "string" && !item.feeMaker.trim()) {
        this.$toastr(
          "error",
          this.$t("trading_fee_setting.validate.required", {
            0: this.$t("tradding_fee_setting.fee_maker"),
          })
        );
        return false;
      }
      let fee_taker = String(item.feeTaker).split(".");
      let fee_maker = String(item.feeMaker).split(".");
      if (
        Number(fee_taker[0]) > 100 ||
        (Number(fee_taker[0]) == 100 && Number(fee_taker[1]) > 0)
      ) {
        this.$toastr(
          "error",
          this.$t("trading_fee_setting.under_101_percent", {
            0: this.$t("tradding_fee_setting.fee_taker"),
          })
        );
        return false;
      }
      if (
        Number(fee_maker[0]) > 100 ||
        (Number(fee_maker[0]) == 100 && Number(fee_maker[1]) > 0)
      ) {
        this.$toastr(
          "error",
          this.$t("trading_fee_setting.under_101_percent", {
            0: this.$t("tradding_fee_setting.fee_maker"),
          })
        );
        return false;
      }
      return true;
    },

    async change(item) {
      if (!item.isDirty) {
        item.feeTaker = new BigNumber(item.feeTaker)
          .toFixed(4)
          .replace(/(?:(\.\d*?[1-2]+)|\.)0*$/gm, "$1");
        item.feeMaker = new BigNumber(item.feeMaker)
          .toFixed(4)
          .replace(/(?:(\.\d*?[1-2]+)|\.)0*$/gm, "$1");
        item.editable = !item.editable;
        return;
      }
      let validator = await this.checkValidatePercent(item);
      if (validator) {
        item.feeTaker = new BigNumber(item.feeTaker)
          .toFixed(4)
          .replace(/(?:(\.\d*?[1-2]+)|\.)0*$/gm, "$1");
        item.feeMaker = new BigNumber(item.feeMaker)
          .toFixed(4)
          .replace(/(?:(\.\d*?[1-2]+)|\.)0*$/gm, "$1");
        ConfirmationModal.show({
          type: "confirm",
          title: this.$t("trading_fee_setting.update_confirm"),
          content: "",
          btnCancelLabel: this.$t("common.action.no"),
          btnConfirmLabel: this.$t("common.action.yes"),
          size: "small",
          onConfirm: () => {
            const params = {
              currency: this.currency.id,
              coin: item.coin,
              membership: this.membership.id.toUpperCase(),
              feeTaker: !item.feeTaker ? 0 : item.feeTaker,
              feeMaker: !item.feeMaker ? 0 : item.feeMaker,
            };
            rf.getRequest("AdminRequest")
              .updateMarketFeeSetting(params)
              .then((res) => {
                item.editable = !item.editable;
                item.isDirty = false;
                this.$toastr(
                  "success",
                  this.$t("trading_fee_setting.update_success_msg")
                );
              })
              .catch((error) => {
                if (!error.response) {
                  this.$toastr(
                    "error",
                    this.$t("common.message.network_error")
                  );
                  return;
                }
              });
          },
          onCancel: () => {},
        });
      }
    },

    revert(item) {
      if (this.isRevertDisabled(item)) return;

      item.feeTaker = item.revert.fee_taker;
      item.feeMaker = item.revert.fee_maker;
      item.isDirty = false;
    },

    validate() {
      const isValidAmountHolding = window._.chain(
        this.$refs.tradeFeeDatatable.rows
      )
        .map((item) => {
          item.level = parseInt(item.level);
          item.mgc_amount = parseInt(item.mgc_amount);
          return item;
        })
        .orderBy(["level"])
        .map((item) => item.mgc_amount)
        .reduce((a, v) => (a !== false && a < v ? v : false), -Infinity)
        .value();
      return isValidAmountHolding;
    },
  },

  mounted() {
    this.$emit("EVENT_PAGE_CHANGE", this);
  },

  created() {
    rf.getRequest("AdminRequest")
      .getPriceGroupCurrency()
      .then((data) => {
        try {
          const ORDER = ["BTC", "USDT", "USDC", "BNB", "ETH"];
          window._.map(data, (item) => {
            if (
              typeof item.currency !== "undefined" &&
              item.currency !== "usd"
            ) {
              const sym = item.currency.toUpperCase();
              if (ORDER.includes(sym))
                this.markets.push({ id: sym.toLowerCase(), name: sym });
            }
          });
          this.markets = window
            ._(this.markets)
            .uniqBy("id")
            .sortBy((o) => ORDER.indexOf(o.name))
            .value();
        } catch (ex) {
          console.error(ex);
        }
      });
  },
};
</script>
<style lang="scss">
@import "@/assets/sass/variables";

#tradingFeeSetting {
  .sc_search_select {
    float: left;
    min-width: 55px;
    .group_search_select {
      .button_drop_search {
        height: 30px !important;
        padding: 5px 10px !important;
        span {
          font-size: $font-small;
          font-family: $mulish-regular;
        }
        i {
          color: $color-grey-dusty;
        }
      }
      .list_search_select {
        li {
          font-size: $font-small;
          font-family: $mulish-regular;
          &:hover,
          &:active,
          &:focus {
            color: $color-jungle-green;
          }
        }
      }
    }
  }
  .filter_container {
    .sc_search_select {
      margin-left: 15px;
      min-width: 85px;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@/assets/sass/variables";
.input-error {
  border: 1px solid $color-denim !important;
}
.per-left {
}
.fl-left {
  float: left;
}
th,
td {
  font-family: $mulish-regular;
  &.trading-coin {
    text-transform: uppercase;
  }
  &.col-coin {
    width: 20%;
  }
  &.col-fee-taker {
    width: 30%;
  }
  &.col-fee-maker {
    width: 30%;
  }
}

.last-table {
  width: 100px;
}
.line_page {
  display: block;
  width: 100%;
  height: 1px;
  background-color: $color_alto;
}
.clearfix-40 {
  display: block;
  clear: both;
  height: 40px;
}

.userInformation {
  .filter_container {
    margin: 10px 0px 20px 0px;
    .title_item {
      color: $color_mine_shaft;
      font-size: $font_big;
      font-family: $mulish-regular;
      line-height: 28px;
      float: left;
    }
    .search_box {
      display: inline-block;
      float: right;
      width: 215px;
      max-width: 100%;
      .search_input {
        background-color: transparent;
        height: 28px;
        border: 1px solid $color_alto;
        padding: 4px 15px;
        line-height: 20px;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: $font-small;
      }
    }
  }
  .datatable {
    .form-control {
      background-color: transparent;
      height: 27px;
      border: 1px solid $color_alto;
      padding: 3px 13px;
      line-height: 20px;
      width: 140px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .btn_edit_network {
    background-color: transparent !important;
    font-size: $font_semi_big;
    color: $color-jungle-green;
    height: 27px;
    padding: 2px;
    line-height: 23px;
    margin-left: 15px;
    &:active {
      box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0);
    }
    &:focus-visible {
      box-shadow: 0 0 0 3px rgba(66, 134, 245, 0.2);
    }
    &:hover {
      color: $color-jungle-green;
    }
  }
  .btn_save_network {
    background-color: transparent !important;
    font-size: $font_semi_big;
    color: $color-jungle-green;
    height: 27px;
    padding: 2px;
    line-height: 23px;
    margin-left: 15px;
    .icon-save:before {
      color: $color-jungle-green;
    }
    &:active {
      box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0);
    }
    &:focus-visible {
      box-shadow: 0 0 0 3px rgba(66, 134, 245, 0.2);
    }
    &:hover {
      color: $color-jungle-green;
      .icon-save:before {
        color: $color-jungle-green;
      }
    }
    &:disabled {
      width: fit-content;
      border: none;
    }
  }
}
</style>
